import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { hide } from 'redux-modal';
import { useDispatch } from 'react-redux';
import FormGroup from '../Formik/FormGroup';
import FavouriteField from '../Formik/FavouriteField';
import { Submit } from '../Formik/Submit';
import { TextInput } from '../utils/forms/TextInput';
import { Button } from '../utils/forms/Button';

function CarForm({ handleSubmit, initialValues }) {
  const dispatch = useDispatch();

  function handleHide() {
    dispatch(hide('newCarModal'));
  }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      <Form>
        <FormGroup>
          <Field
            name="carPlate"
            label="SPZ"
            component={TextInput}
            maxLength={7}
          />
        </FormGroup>
        <FormGroup>
          <Field name="carBrand" label="Značka auta" component={TextInput} />
        </FormGroup>
        <FormGroup>
          <FavouriteField name="favourite" />
        </FormGroup>
        <FormGroup>
          <div className="btn--center">
            <Button type="button" color="secondary" onClick={handleHide}>
              Zrušit
            </Button>
            <Submit
              value={initialValues.carPlate === '' ? 'Upravit' : 'Přidat auto'}
            />
          </div>
        </FormGroup>
      </Form>
    </Formik>
  );
}

CarForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  defaultCar: PropTypes.bool
};

CarForm.defaultProps = {
  defaultCar: false
};

export default CarForm;
